import React, { Component } from 'react'

export default class ExternalCollectionSetupForm extends Component {
  render() {
    return <div>ExternalCollectionSetupForm</div>
  }
}
